import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

interface PrimeComponentEvent {
  originalEvent: Event;
  value: any;
}
interface KnowledgeBaseArticle {
  url: string;
  title: string;
  description: string;
}

@Component({
  selector: 'vnm-support-faq',
  templateUrl: './support-faq.component.html',
  styleUrls: ['./support-faq.component.scss']
})
export class SupportFaqComponent implements OnChanges {
  @Input() scope = 'training-manager';

  header: string;
  subheader: string;
  articles: KnowledgeBaseArticle[];
  kbURL: string;

  constructor(private translateService: TranslateService) {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes.scope) {
      this.articles = Object.values(this.translateService.instant(`support-faq.${this.scope}.articles`));
      this.header = this.translateService.instant(`support-faq.${this.scope}.header`);
      this.subheader = this.translateService.instant(`support-faq.${this.scope}.subheader`);
      this.kbURL = this.translateService.instant(`support-faq.${this.scope}.knowledgebase-url`);
    }
  }

  openArticle(event: PrimeComponentEvent) {
    this.openWindow(event.value.url);
  }

  openWindow(url: string) {
    window.open(url);
  }
}
